module.exports = __webpack_public_path__ + "img/file-richtext.00734f98.svg";